module.exports = __webpack_public_path__ + "static/media/pumpkin.caefd17f.svg";